import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InboxComponent } from '@/shared/components/general/inbox/inbox.component';
import { DialogService } from 'primeng/dynamicdialog';
import { ChangeDetectionStrategy } from '@angular/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PanelModule } from 'primeng/panel';
import { FieldsetModule } from 'primeng/fieldset';
import {
  ICaptchaRadicadoForm,
  IConsultaCaptchaForm,
  IConsultaIdentificacionForm,
  IConsultaRadicadoForm,
} from './interfaces/consulta-externa-pqrs.interface';
import { FormBuilderService } from './service/form-builder.service';
import { ConsultaExternaPqrsService } from './service/consulta-pqrs.service';
import { DatePickerModule } from 'primeng/datepicker';
import { LayoutService } from '@/layout/service/layout.service';
import { CardModule } from 'primeng/card';
import { ModalGenericComponent } from '@/shared/components/general/modal-generic/modal-generic.component';
import { RegistroUsuarioComponent } from './component/registro-usuario/registro-usuario.component';
import { EActionEventCrud } from '@/common/enums/general.enum';
import { RealizarPqrsComponent } from './component/realizar-pqrs/realizar-pqrs.component';
import { ConsultasPqrsService } from './component/consulta-pqrs/consulta-pqrs.service';
import { MessageService } from 'primeng/api';
import { ConsultasPqrsComponent } from './component/consulta-pqrs/consulta-pqrs.component';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-consulta-pqrs',
  standalone: true,
  providers: [DialogService],
  imports: [
    // Angular modules
    CommonModule,
    ReactiveFormsModule,
    // PrimeNG modules
    TableModule,
    ButtonModule,
    DialogModule,
    MultiSelectModule,
    PanelModule,
    FieldsetModule,
    DatePickerModule,
    CardModule,
    // Componentes
    InboxComponent,
  ],
  templateUrl: './consulta-pqrs.component.html',
  styleUrl: './consulta-pqrs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsultaPqrsComponent implements OnInit {
  formcaptcha!: FormGroup<IConsultaCaptchaForm>;
  formIdentificacion!: FormGroup<IConsultaIdentificacionForm>;
  formcaptchaRadicado!: FormGroup<ICaptchaRadicadoForm>;
  formConsultaRadicado!: FormGroup<IConsultaRadicadoForm>;
  // Captcha 1 (Identificación)
  captchaImage = '';
  captchaToken = '';
  captchaValido = false;
  // Captcha 2 (Radicado)
  captchaImageRadicado = '';
  captchaTokenRadicado = '';
  captchaValidoRadicado = false;
  mostrarInbox = false;

  consultasPqrsService = inject(ConsultasPqrsService);
  service = inject(ConsultaExternaPqrsService);
  messageService = inject(MessageService);
  layoutService = inject(LayoutService);
  dialogService = inject(DialogService);

  constructor(
    private fbService: FormBuilderService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.formIdentificacion =
      this.fbService.buildFormConsultaIdentificacionPqr();
    this.formConsultaRadicado = this.fbService.buildFormConsultaRadicadoPqr();
    this.formcaptcha = this.fbService.buildFormcaptcha();
    this.formcaptchaRadicado = this.fbService.buildFormcaptchaRadicado();
    this.service.setHeaderTable();
    this.getCaptcha();
    this.getCaptchaRadicado();
  }

  getCaptcha() {
    this.consultasPqrsService.getGenerateCaptchat().subscribe((resp: any) => {
      this.captchaImage = 'data:image/png;base64,' + resp.Data.image;
      this.captchaToken = resp.Data.token;
      this.cd.detectChanges();
    });
  }
  getCaptchaRadicado() {
    this.consultasPqrsService.getGenerateCaptchat().subscribe((resp: any) => {
      this.captchaImageRadicado = 'data:image/png;base64,' + resp.Data.image;
      this.captchaTokenRadicado = resp.Data.token;
      this.cd.detectChanges();
    });
  }

  validarCaptcha() {
    const userInput = this.formcaptcha.value.UserInput;

    if (!userInput) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atención',
        detail: 'Por favor digite el captcha',
      });
      return;
    }

    const body = {
      token: this.captchaToken,
      UserInput: userInput,
    };

    this.consultasPqrsService
      .postvalidateCaptchat(body)
      .subscribe((resp: any) => {
        if (resp.Data?.isValid === true) {
          this.captchaValido = true;
          this.cd.detectChanges();
        } else {
          this.captchaValido = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Captcha incorrecto',
          });
          this.getCaptcha();
        }
      });
  }

  validarCaptchaRadicado() {
    const userInput = this.formcaptchaRadicado.value.UserInputt;

    if (!userInput) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atención',
        detail: 'Por favor digite el captcha',
      });
      return;
    }

    const body = {
      token: this.captchaTokenRadicado,
      UserInput: userInput,
    };

    this.consultasPqrsService
      .postvalidateCaptchat(body)
      .subscribe((resp: any) => {
        if (resp.Data?.isValid === true) {
          this.captchaValidoRadicado = true;
          this.cd.detectChanges();
          this.messageService.add({
            severity: 'success',
            summary: 'Correcto',
            detail: 'Captcha validado correctamente',
          });
        } else {
          this.captchaValidoRadicado = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Captcha incorrecto',
          });

          this.getCaptchaRadicado();
        }
      });
  }

  async onBuscarIdentificacion() {
    const numero = this.formIdentificacion.get('Identificacion')?.value;
    if (!numero) return;

    const data = await lastValueFrom(this.service.getData(Number(numero)));

    if (data.data) {
      this.service.onLoadRecords(data.pagination);
      this.mostrarInbox = true;
    } else {
      this.mostrarInbox = false;
      this.mostrarModalNoExiste();
    }
  }

  mostrarModalNoExiste() {
    const isDarkMode = document.documentElement.classList.contains('dark');

    const ref = this.dialogService.open(ModalGenericComponent, {
      header: 'CODIGO DE PQRS NO EXISTE!',
      width: '350px',
      style: { margin: 0, padding: 0 },
      modal: true,
      closable: true,
      maximizable: true,
      dismissableMask: true,

      contentStyle: {
        margin: 0,
        padding: 0,
        borderRadius: 0,
        background: isDarkMode ? '#111827' : '#ffffff',
        color: isDarkMode ? '#ffffff' : '#000000',
        opacity: '1',
      },

      data: {
        title: '¡VERIFIQUE!',
        message: 'Por favor, regrese al botón y registre un usuario',
        tipoConfirmacion: 'success',
        cancelLabel: 'Cerrar',
      },
    });

    ref.onClose.subscribe(() => {
      this.formIdentificacion.reset();
      ref.close({ recargar: true });
    });
  }

  newRegisterPqrs() {
    const identificacion = this.formIdentificacion.get('Identificacion')?.value;
    const ref = this.dialogService.open(RealizarPqrsComponent, {
      header: 'Realice su PQRS',
      style: { margin: 0, padding: 0 },
      width: '60%',
      modal: true,
      closable: true,
      maximizable: true,
      dismissableMask: true,
      contentStyle: {
        margin: 0,
        padding: 0,
        radius: 0,
      },
      data: {
        action: EActionEventCrud.NA,
        record: {},
        permissionsView: 'NT',

        NumeroDocumento: identificacion,
      },
    });
    ref.onClose.subscribe((resp) => {
      if (resp?.recargar) {
        this.onBuscarIdentificacion();
        return;
      }
    });
  }

  onRegistroUsuario(): void {
    const ref = this.dialogService.open(RegistroUsuarioComponent, {
      header: 'Registre Un Nuevo Usuario',
      width: '60%',
      style: { margin: 0, padding: 0 },
      modal: true,
      closable: true,
      maximizable: true,
      dismissableMask: true,
      contentStyle: {
        margin: 0,
        padding: 0,
        radius: 0,
      },
      data: {
        action: EActionEventCrud.NA,
        record: {},
        permissionsView: 'NT',
      },
    });
    ref.onClose.subscribe(() => {
      ref.close({ recargar: true });
    });
  }

  onBuscarRadicado(): void {
    const cod = this.formConsultaRadicado.get('CodRadicado')?.value;
    if (!cod) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validación',
        detail: 'Debe ingresar un número de radicado.',
      });
      return;
    }
    this.consultasPqrsService.getPqrsRadicado$(cod).subscribe({
      next: (resp) => {
        if (resp?.estado && resp?.data) {
          const ref = this.dialogService.open(ConsultasPqrsComponent, {
            header: 'Consulta de PQRS',
            style: { margin: 0, padding: 0 },
            width: '50%',
            modal: true,
            closable: true,
            maximizable: true,
            dismissableMask: true,
            contentStyle: {
              margin: 0,
              padding: 0,
              radius: 0,
            },
            data: {
              action: EActionEventCrud.NA,
              record: resp.data,
              permissionsView: 'NT',
            },
          });

          ref.onClose.subscribe(() => {
            // this.formIdentificacion.reset();
          });
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Sin resultados',
            detail: 'No se encontró información para el radicado.',
          });
        }
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo consultar el radicado.',
        });
      },
    });
  }
}
